interface NavigationProps {
  scrolled: boolean;
}

export default function Navigation({ scrolled }: NavigationProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4">
        <div className="flex items-center justify-center md:justify-between">
          <div className="flex items-center">
            <img
              src="https://public.readdy.ai/ai/img_res/a6415dae-d67c-469c-bfb4-25a94ed7f239.png"
              alt="William and Mary Wedding Logo"
              className="h-10 sm:h-12 w-auto object-contain"
            />
          </div>
          <div className="hidden md:flex items-center gap-8">
            <a
              href="#home"
              className="text-sm font-light tracking-wide hover:text-gray-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Home
            </a>
            <a
              href="#event-details"
              className="text-sm font-light tracking-wide hover:text-gray-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Event Details
            </a>
            <a
              href="#couple-bio"
              className="text-sm font-light tracking-wide hover:text-gray-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Our Story
            </a>
            <a
              href="#rsvp"
              className="text-sm font-light tracking-wide hover:text-gray-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              RSVP
            </a>
            <a
              href="#contact"
              className="text-sm font-light tracking-wide hover:text-gray-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Contact
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
